import { TypographyV3 } from '@jouzen/ecom-components';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';

import type { PopTechSpecsFeatureData } from '@/app/[locale]/product/rings/_types';

import PopBottomEyebrow from '../PopBottomEyebrow';

export type PopTechSpecsFeatureProps = Omit<PopTechSpecsFeatureData, 'id'>;

const PopTechSpecsFeature = ({
  copy,
  copyWrapper = 'p',
  Icon,
  title,
}: PopTechSpecsFeatureProps): JSX.Element => {
  const t = useTranslations();

  return (
    <div data-cy="pop_tech_specs_feature">
      <Icon className="mb-5 size-5 lg:size-6" />
      <PopBottomEyebrow className="mb-3" Element="h3">
        {t(title)}
      </PopBottomEyebrow>
      <TypographyV3
        className={cx('text-sm', {
          'flex flex-col gap-y-2': copyWrapper === 'ul',
        })}
        color="inherit"
        Element={copyWrapper}
      >
        {t.rich(copy)}
      </TypographyV3>
    </div>
  );
};

export default PopTechSpecsFeature;
